import { Submission } from '@/main/app/schema'
import type { ItemWithData, SubmissionResult } from '@/main/features/List/listSlice'

interface CompareDifferences {
  isNotEqual: (ItemWithData & { change: number })[]
  isEqual: ItemWithData[]
}

function differenceById(left: ItemWithData[], right: ItemWithData[]) {
  return left.filter((l) => !right.some((r) => r.id == l.id))
}

export function compareHistory(
  formValues: Submission,
  currentItems: ItemWithData[],
  cartHistory: SubmissionResult
) {
  const previousItems = cartHistory.items
  const previousItemHash = Object.fromEntries(previousItems.map((item) => [item.id, item]))

  const { isNotEqual, isEqual } = currentItems.reduce(
    (all: CompareDifferences, item) => {
      if (!previousItemHash[item.id]) return all

      if (previousItemHash[item.id].count === item.count) {
        all.isEqual.push(item)
      } else {
        all.isNotEqual.push({ ...item, change: item.count - previousItemHash[item.id].count })
      }

      return all
    },
    { isNotEqual: [], isEqual: [] }
  )

  const add = differenceById(currentItems, previousItems)
  const remove = differenceById(previousItems, currentItems)

  const lastStart =
    cartHistory.dates.startDate !== formValues.dates.startDate && cartHistory.dates.startDate
  const lastEnd =
    cartHistory.dates.endDate !== formValues.dates.endDate && cartHistory.dates.endDate

  return {
    lastStart,
    lastEnd,
    add,
    remove,
    keep: isEqual,
    change: isNotEqual,
  }
}
